import { useEffect } from 'react'

import {
  HelmetProvider,
  type HelmetDataContext,
} from '@dr.pogodin/react-helmet'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import 'dayjs/locale/de'
import 'dayjs/locale/fr'
import 'dayjs/locale/pl'
import 'dayjs/locale/en'
import { useTranslation } from 'react-i18next'
import {
  CurrentPage,
  NotFoundErrorPage as ScrivitoNotFoundErrorPage,
} from 'scrivito'

import { CurrentPageMetadata } from './Components/CurrentPageMetadata'
import { DesignAdjustments } from './Components/DesignAdjustments'
import { ErrorBoundary } from './Components/ErrorBoundary'
import { NotFoundErrorPage } from './Components/NotFoundErrorPage'
import { SidebarContextProvider } from './Components/Sidebar/SidebarContext'
import { ToastContainer } from './Components/Toast/ToastContainer'
import { FeatureFlagProvider } from './hooks/useFeatureFlagHandler'
import { AiChatBot } from '@/Atomic/Widgets/AiChatBot'

import './config/i18nInit'

export const helmetContext: HelmetDataContext = {}

export function App({
  appWrapperRef,
}: {
  appWrapperRef?: React.RefCallback<HTMLElement>
}) {
  const { i18n } = useTranslation()
  const locale = i18n.resolvedLanguage || 'en'

  useEffect(() => {
    dayjs.locale(locale)
  }, [locale])

  return (
    <HelmetProvider context={helmetContext}>
      <ErrorBoundary>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
          <FeatureFlagProvider>
            <SidebarContextProvider>
              <div ref={appWrapperRef} style={{ display: 'contents' }}>
                <CurrentPage />
                <ScrivitoNotFoundErrorPage>
                  <NotFoundErrorPage />
                </ScrivitoNotFoundErrorPage>
                <CurrentPageMetadata />
                <ToastContainer />
                <DesignAdjustments />
              </div>
              <AiChatBot headless />
            </SidebarContextProvider>
          </FeatureFlagProvider>
        </LocalizationProvider>
      </ErrorBoundary>
    </HelmetProvider>
  )
}
